import React, { useContext } from "react";
import { useNotification } from "../../common/hooks/useNotification";

const NotificationContext = React.createContext({
  notify: undefined,
  close: undefined,
});

export const useNotificationContext = () => useContext(NotificationContext);

export const NotificationContextProvider = ({ children }) => {
  const { notify, contextHolder, close } = useNotification();

  return (
    <NotificationContext.Provider
      value={{
        notify,
        close,
      }}
    >
      {contextHolder}
      {children}
    </NotificationContext.Provider>
  );
};
